<template>
  <b-container id="menuSite">
    <b-row id="containerMenu">
      <router-link id="logoSite" class="d-none d-md-block" to="/" exact>
        <img class="img-fluid" :src="logoTopo" />
      </router-link>
      <div v-if="client === 'CUIABA'" id="tituloSite">
        <h1>
          {{ tituloTopo }}
        </h1>
        <hr />
        <h4>
          {{ descricaoTopo }}
        </h4>
      </div>

      <div v-if="client === 'DOE-AL'" id="imagemTopo">
        <img class="img-fluid" :src="imagemTopo" />
      </div>

      <div v-if="client !== 'DOE-AL'">
        <div id="fundoMenu" class="d-none d-md-block">
          <ul class="nav pl-lg-4 w-100">
            <li class="nav-item">
              <router-link class="nav-link" to="/" exact>Home</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/busca">Busca</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/edicoes">Edições</router-link>
            </li>
            <!-- <li v-if="client === 'CUIABA'" class="nav-item">
              <router-link class="nav-link" to="/busca-legislacoes">Busca de Legislações</router-link>
            </li> -->
            <li v-if="client === 'CUIABA'" class="nav-item">
              <router-link class="nav-link" to="/legislacoes">
                Legislações
              </router-link>
            </li>
            <li v-if="client === 'CUIABA'" class="nav-item">
              <router-link class="nav-link" to="/sobre">Sobre</router-link>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="client === 'DOE-AL'" id="fundoMenu" class="d-none d-md-block">
        <ul class="nav pl-lg-4 w-100">
          <li class="nav-item">
            <router-link class="nav-link" to="/" exact>Home</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/busca">Busca</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/edicoes">Edições</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/publicar-no-diario"
              >Publicar no Diário Oficial</router-link
            >
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/sobre">Sobre</router-link>
          </li>
        </ul>
      </div>

      <!-- Area Mobile -->
      <router-link
        id="logoSiteMobile"
        class="d-block d-sm-block d-md-none py-1 my-1"
        to="/"
        exact
      >
        <img class="img-fluid" :src="logoTopo" />
      </router-link>
      <div id="fundoMenuMobile" class="d-block d-sm-block d-md-none">
        <b-navbar toggleable="md" type="dark">
          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
          <b-navbar-brand v-if="client !== 'CUIABA'" href="#">{{
            titleMobile
          }}</b-navbar-brand>
          <b-collapse is-nav id="nav_collapse">
            <ul class="nav nav-pills nav-fill">
              <li variant="cinzaClaro" class="nav-item">
                <router-link class="nav-link" variant="cinzaClaro" to="/" exact>
                  Home
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/busca"> Busca </router-link>
              </li>
              <!-- <li v-if="client === 'CUIABA'" class="nav-item">
                <router-link class="nav-link" to="/busca-legislacoes">
                  Busca de Legislações
                </router-link>
              </li> -->
              <li class="nav-item">
                <router-link class="nav-link" to="/edicoes">
                  Edições
                </router-link>
              </li>
              <li v-if="client === 'CUIABA'" class="nav-item">
                <router-link class="nav-link" to="/legislacoes">
                  Legislações
                </router-link>
              </li>
              <li v-if="client === 'DOE-AL'" class="nav-item">
                <router-link class="nav-link" to="/publicar-no-diario">
                  Publicar no Diário Oficial
                </router-link>
              </li>
              <li
                v-if="client === 'CUIABA' || client === 'DOE-AL'"
                class="nav-item"
              >
                <router-link class="nav-link" to="/sobre"> Sobre </router-link>
              </li>
            </ul>
          </b-collapse>
        </b-navbar>
      </div>
    </b-row>
  </b-container>
</template>

<script>
  import client from '@/main.js'
  export default {
    name: 'Menu',
    data() {
      return {
        client: null,
        logoTopo: '',
        imagemTopo: '',
        titleMobile: '',
        tituloTopo: 'GAZETA MUNICIPAL',
        descricaoTopo: `Prefeitura Municipal de Cuiabá - MT`,
        formLogin: {
          usuario: '',
          senha: ''
        }
      }
    },
    created() {
      let me = this
      me.client = client.CLIENT
      me.titleMobile = client.clientData.titleMobile
      me.logoTopo = require('@/assets/imagens/' + me.client + '/logo.png')
      if (me.client === 'DOE-AL') {
        me.imagemTopo = require('@/assets/imagens/' +
          me.client +
          '/logo_diario.png')
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault()
        alert(JSON.stringify(this.formLogin))
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/estilos.scss';
  #logoSite {
    width: 175px;
    height: 175px;
    border: 4px solid #fff;
    // box-shadow: 3px 0 4px 0 rgba(0,0,0,0.2);
    // z-index: 1;
  }
  #logoSiteMobile {
    text-align: center;
    width: 85px;
    height: 80px;
    height: auto;
    background-color: $corPrimaria;
    background-color: $corBotaoDestaque;
    img {
      height: 75px;
    }
  }
  #tituloSite {
    position: absolute;
    width: calc(100% - 175px);
    margin: 0;
    top: 0;
    right: calc(175px / 2);
    margin-top: 45px;
    text-align: center;
    h1 {
      font-size: 32pt;
      font-weight: bolder;
      margin-bottom: 0;
      line-height: 0.75rem;
    }
    hr {
      width: 520px;
      border: none;
      border-top: 2px solid $corPrimaria;
      margin: 1rem auto 0.2rem;
    }
    h4 {
      font-size: 1.5rem;
      margin-bottom: 0;
    }
  }
  #imagemTopo {
    position: absolute;
    width: calc(100% - 265px);
    margin: 0;
    top: 28px;
    right: 120px;
    text-align: center;
  }
  #menuSite {
    #containerMenu {
      position: relative;
      #containerLogin {
        position: absolute;
        top: 25px;
        right: 0;
        z-index: 2;
        #formLogin {
          height: 25px;
          display: inline-flex;
          width: 350px;
          margin-bottom: 0.1rem;
          .campoLogin {
            padding-left: 2px;
            padding-right: 2px;
          }
          .form-group {
            .btn {
              margin-top: -1px;
              padding: 0.3rem 0.35rem;
              line-height: 0.5;
            }
            margin-bottom: 0.5rem;
          }
          .form-control {
            padding: 0.175rem 0.75rem;
            font-size: 13px;
          }
        }
      }
    }
    #fundoMenu {
      background-color: rgba(255, 255, 255, 0.95);
      // width: calc(100% - 179px);
      width: auto;
      height: 55px;
      margin: 0;
      margin-top: 120px;
      .nav {
        height: 55px;
        text-align: right;
        float: left;
        .nav-item {
          margin-right: 10px;
          min-width: 120px;
          text-align: center;
          &:last-child {
            margin-right: 0;
          }
          .nav-link {
            margin-top: 5px;
            height: 50px;
            line-height: 35px;
            font-weight: 500;
            padding: 0.5rem 2rem;
            vertical-align: middle;
            color: #000;
            background-color: rgba($corPrimaria, 0.08);
            border-bottom: 0 $corPrimaria solid;
            transition: all 150ms ease-out;
            -moz-transition: all 150ms ease-out;
            -webkit-transition: all 150ms ease-out;
          }
          .nav-link:hover {
            background-color: red;
            background-color: rgba($corPrimaria, 0.1);
            border-bottom: 4px $corPrimaria solid;
            transition: all 150ms ease-in;
            -moz-transition: all 150ms ease-in;
            -webkit-transition: all 150ms ease-in;
          }
          .nav-link.active {
            color: #fff;
            background-color: $corPrimaria;
            cursor: default;
          }
        }
      }
    }
    #fundoMenuMobile {
      width: 100%;
      background-color: $corBotaoDestaque;
      .navbar {
        .navbar-toggler {
          background-color: $corPrimaria;
        }
        .navbar-brand {
          color: $corPrimaria;
          font-size: 0.9rem;
        }
        #nav_collapse {
          .nav {
            .nav-item {
              width: 100%;
              .nav-link {
                width: 100%;
                color: #000;
              }
              .nav-link.active {
                color: #fff;
                background-color: $corPrimaria;
              }
            }
          }
        }
      }
    }
    /* Media Queries */
    /* xs and sm */
    @media (max-width: 767.98px) {
      #tituloSite {
        width: calc(100% - 85px);
        right: 10px;
        margin-top: 35px;
        h1 {
          font-size: 1.4rem;
          margin-bottom: 0;
          line-height: 0.1rem;
        }
        hr {
          width: 100%;
          margin: 0.75rem auto 0.2rem;
        }
        h4 {
          font-size: 0.83rem;
        }
      }
      #imagemTopo {
        width: calc(100% - 125px);
        top: 22px;
        right: 22px;
      }
    }
    /* Tablets */
    /* iPad */
    @media (min-width: 768px) and (max-width: 991.98px) {
      #tituloSite {
        width: calc(100% - 190px);
        right: 10px;
        hr {
          width: 100%;
        }
      }
      #imagemTopo {
        width: calc(100% - 165px);
        top: 40px;
        right: 15px;
      }
      #fundoMenu {
        margin-top: 0px;
        .nav {
          .nav-item {
            margin-right: 5px;
            min-width: 100px;
            text-align: center;
          }
        }
      }
    }
    /* iPad Pro */
    @media (min-width: 992px) and (max-width: 1024.98px) {
      #tituloSite {
        width: calc(100% - 330px);
        right: 100px;
        h1 {
          font-size: 2rem;
          line-height: 0.4rem;
        }
        hr {
          width: 100%;
        }
        h4 {
          font-size: 1.5rem;
        }
      }
      #fundoMenu {
        .nav {
          .nav-item {
            margin-right: 7px;
            min-width: 110px;
            text-align: center;
          }
        }
      }
    }
    /* xs */
    @media (max-width: 355px) {
      #tituloSite {
        width: calc(100% - 85px);
        right: 10px;
        margin-top: 35px;
        h1 {
          font-size: 1.3rem;
          margin-bottom: 0;
          line-height: 0.1rem;
        }
        hr {
          width: 100%;
          margin: 0.75rem auto 0.2rem;
        }
        h4 {
          font-size: 0.75rem;
        }
      }
      #imagemTopo {
        width: calc(100% - 75px);
        top: 25px;
        right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/menu.vue